import { ContainerModule, interfaces } from '@theia/core/shared/inversify';
import { FrontendApplicationContribution } from '@theia/core/lib/browser';
// import { IframeListenerFrontendContribution } from './iframe-listener-frontend-contribution';
import { DebugFrontendApplicationContribution } from '@theia/debug/lib/browser/debug-frontend-application-contribution';
import { RenesasDebugConsoleContribution } from './debug-console-contribution';
import { IframeListenerService } from './iframe-listener-service';
import { RenesasFrontendApplication } from './renesas-frontend-application';


export default new ContainerModule((bind: interfaces.Bind,
                                    _unbind: interfaces.Unbind,
                                    isBound: interfaces.IsBound,
                                    rebind: interfaces.Rebind,
) => {
    bind(IframeListenerService).toSelf().inSingletonScope();

    bind(RenesasFrontendApplication).toSelf().inSingletonScope();
    bind(FrontendApplicationContribution).toService(RenesasFrontendApplication);

    bind(RenesasDebugConsoleContribution).toSelf().inSingletonScope();
    rebind(DebugFrontendApplicationContribution).toService(RenesasDebugConsoleContribution);

    // bind(FrontendApplicationContribution).to(IframeListenerFrontendContribution).inSingletonScope();
});
